import mongoose from 'mongoose';
import schema, { IReverseGeoCodeCacheDocument } from '../schemas/reverse-geocode-cache';

const ReverseGeoCodeCache = (mongoose.models.ReverseGeoCodeCache ||
  mongoose.model<IReverseGeoCodeCacheDocument>('ReverseGeoCodeCache', schema)) as mongoose.Model<
  IReverseGeoCodeCacheDocument
>;

export default ReverseGeoCodeCache;
